import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { LanguageProvider, initialStateEnglish, initialStateFrench } from './contexts/LanguageProvider';
import { AppStateProvider, initialState } from './contexts/AppStateProvider';

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider initialState={(document.documentElement.lang === 'fr') ? initialStateFrench : initialStateEnglish}>
      <AppStateProvider initialState={initialState}>
        <App />
      </AppStateProvider>
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// document.querySelectorAll('.tooltip-root').forEach((el) => {
//   const tooltipText = el.dataset.tooltipText || 'Info tooltip';
//   ReactDOM.render(<Tooltip text={tooltipText} size="small" />, el);
// });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
